/**
 * «Hoy» para toda la app. En la demostración se fija al día en que se inventaron los datos: así lo de «este mes»
 * siempre tiene movimientos, se abra cuando se abra.
 */
let fixed: string | null = null;
const p = (n: number) => String(n).padStart(2, '0');

export const setFixedToday = (iso: string | null) => { fixed = iso && /^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso : null; };
export const today = (): string => { if (fixed) return fixed; const d = new Date(); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`; };
